import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.scss';

const Footer = ({ isPrivate }) => {

    const { t } = useTranslation();

    const footerLinks = [
        {
            label: t('Footer.legal'),
            url: '/legal',
            isPublic: true,
            isExternal: false
        },
        {
            label: t('Footer.privacy'),
            url: '/privacy',
            isPublic: true,
            isExternal: false
        },
        /*{
            label: t('Footer.cookies'),
            url: '/cookies',
            isPublic: true,
            isExternal: false
        },*/
        {
            label: t('Footer.accessibility'),
            url: '/accessibility',
            isPublic: true,
            isExternal: false
        },
        {
            label: t('Footer.sitemap'),
            url: '/sitemap',
            isPublic: true,
            isExternal: false
        },
        {
            label: t('Footer.apps'),
            url: 'https://bonoculturajoven.gob.es/apps-moviles.html',
            isPublic: true,
            isExternal: true
        }
    ];

    const shouldShowLink = (link) => {
        return isPrivate || link.isPublic;
    };

    return (
        <footer className={`Footer ${isPrivate ? 'Footer--private' : ''}`}>
            <div className="container">
                <div className="row mb-3 mb-xl-5">
                    <div className="col-12">
                        <nav className="Footer__nav">
                            <ul className="list-unstyled d-flex flex-wrap justify-content-center mb-0 | Footer__menu">
                                {footerLinks
                                    .filter(shouldShowLink)
                                    .map((link, index) => (
                                        <li key={index} className="Footer__item">
                                            {
                                                link.isExternal ?
                                                    <a href={link.url} target="_blank" rel="noreferrer" className="Footer__link">{link.label}</a>
                                                :
                                                    <Link to={link.url} className="Footer__link">{link.label}</Link>
                                            }
                                        </li>
                                    ))}
                            </ul>
                        </nav>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <p className="Footer__copyright">{t('Footer.copyright')}</p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
